module.exports = __webpack_public_path__ + "img/esconder.3acc1e18.svg";